
/**
 * 강의 난이도
 */
export type CourseDetailSummaryLevel = typeof CourseDetailSummaryLevel[keyof typeof CourseDetailSummaryLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDetailSummaryLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
